import { useAuth } from "@/context/AuthContext";
import { KeyRound } from "lucide-react";

export function PreviewBanner() {
  const { user } = useAuth();
  if (!user || user.role !== "admin") return null;
  return (
    <div className="mb-8 flex flex-wrap items-center gap-x-3 gap-y-1 border border-primary/40 bg-primary/10 px-5 py-3" data-testid="preview-banner">
      <span className="flex items-center gap-2 text-primary">
        <KeyRound className="h-4 w-4" />
        <span className="label-caps">All-Grades Preview Mode</span>
      </span>
      <span className="text-sm text-muted-foreground">
        You can browse and test every grade level. Quiz scores here are <strong className="text-foreground">not saved</strong> to any gradebook.
      </span>
    </div>
  );
}
